/*jshint esversion: 6 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { PaymentWhiteLabelAdminAPI } from '../../services/wladmin/paymentWhiteLabelAdminAPI';


@inject(AuthService, Router, PaymentWhiteLabelAdminAPI, UserMessageService)
export class Pricing {
  constructor(authService, router, api, userMessageService) {
    this.authService = authService;
    this.router = router;
    this.api = api;

    this.userMessageService = userMessageService;
  
    this.saving = false;
    this.loading = true;

    this.structureType = "0";

    this.packageList = [];

    this.monthlyLicenseFee = 0;
    this.amount = 0;
    this.type = 0;
  }

  activate(params) {
    this.loading = true;
    this.perVideoPrice = 0;
    this.plusPrice = 0;
      
    this.load();

  }

  load() {
    this.api.getWLRPriceStructure(
      this.authService.getUser().whitelabel_id,
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this));
  }


  save() {
    if (this.validate()) {
      this.saving = true;
      this.api.setWLRPriceStructure(
        this.getData(),
        this.authService.getUser().token,
        this.saveSetLoadSuccess.bind(this),
        this.saveLoadError.bind(this));

      
   
    }
  }

 

  saveLoadSuccess(data) {
    this.loading = false;
    this.setData(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
    }
    this.saving = false;
  }

  saveSetLoadSuccess (data) {
    this.loading = false;
    this.setSaveData(data);

    if (this.saving) {
      this.userMessageService.setUserMessage('user', 'Saved!');
    }
    this.saving = false;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
    this.loading = false;
    this.saving = false;
  }


  setSaveData(data) {
    if(data) {
      this.monthlyLicenseFee = data.result? data.result.monthly_fees : 0;
      this.perVideoPrice = data.result? data.result.pay_per_video : 0;
      this.plusPrice = data.result? data.result.plus_user : 0;
      this.type = data.result? data.result.type : 0;
      this.structureType = this.type == 1? "1" : "0" ;
      }
  

  }


  setData(data) {
  

    if(data) {
    this.monthlyLicenseFee = data.result? data.result.MONTHLY_FEES : 0;
    this.perVideoPrice = data.result? data.result.PAY_PER_VIDEO : 0;
    this.plusPrice = data.result? data.result.PLUS_USER : 0;
    this.type = data.result? data.result.TYPE : 0;
    this.structureType = this.type == 1? "1" : "0" ;
    }

  }



  getData() {

    this.amount = this.structureType == 0 ? this.perVideoPrice : this.plusPrice;
    this.type = this.structureType == 0 ? 0 : 1;

    var data = {
      "wl_id" : this.authService.getUser().whitelabel_id, 
      "monthly_fees": this.monthlyLicenseFee, 
      "pay_per_video" : this.perVideoPrice,
      "plus_user" : this.plusPrice,
      "type" : this.type
    }

    return data
   
  }

  addPackage() {
    this.packageList.push({
      "display_value": "",
      "unit_cost": 0,
      "quantity": 1
    });
  }

  validate() {
    var pass = true;

    var data = this.getData();

    for(var i = 0; i < data.length; i++) {
      if(data[i].display_value === null || data[i].display_value.trim() == '' ) {
        this.userMessageService.setUserError('user', 'Display Value is empty');
        pass = false;
      }

      if(data[i].unit_cost == 0 ) {
        this.userMessageService.setUserError('user', 'Unit Cost is empty');
        pass = false;
      }

      if(data[i].quantity == 0 ) {
        this.userMessageService.setUserError('user', 'Quantity is empty');
        pass = false;
      }
    }

    return pass;
  }

  delete($index, $event) {
    $event.stopPropagation();
    if(confirm("Delete this Package?")) {
        this.packageList.splice($index, 1);
    }

  }


}
